import React from 'react';
import "../../Styles/pagination.css";

const Pagination = ({ totalItems, itemsPerPage, page, setPage, handlePrev, handleNext, handlePage }) => {
  if (totalItems / itemsPerPage <= 1) return null;

  const length = Math.ceil(11 / itemsPerPage);

  if (!itemsPerPage) return null;

  return (
    <section className="pagination-section">
      <div className="container">
        <nav aria-label="Page navigation example">
          <ul className="pagination">
            <li className="prev">
              <a
                className="prev-link"
                onClick={handlePrev}
                style={{ pointerEvents: page === 1 ? 'none' : 'auto', opacity: page === 1 ? 0.5 : 1 }}
              >
                Prev
              </a>
            </li>
            {[...Array(length)].map((_, index) => (
              <li key={index + 1} className="page-item">
                <a
                  className={`page-link ${page === index + 1 ? "active" : ""}`}
                  onClick={() => handlePage(index + 1)}
                >
                  {index + 1}
                </a>
              </li>
            ))}
            <li className="next">
              <a
                className="next-link"
                onClick={handleNext}
                style={{ pointerEvents: page === totalItems ? 'none' : 'auto', opacity: page === totalItems ? 0.5 : 1 }}
              >
                Next
              </a>
            </li>
          </ul>
        </nav>
      </div>
    </section>
  );
};

export default Pagination;
